module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/LUTHER_S05.432d1c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/LUTHER_S05.jpg
// module id = Da3Y
// module chunks = 0